import React from 'react';
import KaModal from '../Common/KaModal';
import SiteDto from '../Common/dtos/RegisteredSiteDto';
import SiteUpsertDto from '../Common/dtos/SiteUpsertDto';
import SpinnerButton from '../Common/SpinnerButton';
import { Path, useForm } from 'react-hook-form';
import { RowFormText } from '../Common/Forms/FormText';
import { useDisplayMessage } from '../Common/useDisplayMessage';
import KaAlert from '../Common/KaAlert';
import useUpdateSite from '../../requests/useUpdateSite';

export interface IProps {
  initialSite: SiteDto,
  onHide: () => void,
  onSuccess: (site: SiteUpsertDto) => void,
}

export const EditSite = (props: IProps) => {
  const displayMessage = useDisplayMessage();
  const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm<SiteUpsertDto>({
    defaultValues: { name: props.initialSite.name }
  });

  const useEdit = useUpdateSite(props.initialSite.id, {
    onSuccess: () => props.onSuccess(getValues()),
    onError: (e) => displayMessage.fail(e.message),
  });

  const handleUpdate = (siteUpsert: SiteUpsertDto) => {
    useEdit.request(siteUpsert);
  }

  const hookProps = (name: Path<SiteUpsertDto>) => ({
    labelSpace: 4,
    inputSpace: 7,
    name: name,
    setValue,
    register,
    errors,
  });

  const onClose = () => {
    props.onHide();
    displayMessage.clear();
  }

  return (<KaModal
    onHide={onClose}
    show={true}
    title="Update a site"
    body={(<>
      <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
      <RowFormText displayName="Site Name"
        {...hookProps("name")}
        options={{
          required: 'Name is required',
          validate: {
            length: v => v.length < 101 || 'Name cannot be longer than 100 characters'
          },
          pattern: {
            value: /^[^,]*$/i,
            message: 'Name cannot contain commas'
          }
        }}
      />
    </>)}
    footer={(
      <SpinnerButton
        className="btn-ghost-primary"
        spinning={useEdit.isLoading}
        onClick={handleSubmit(handleUpdate)}>
        Update
      </SpinnerButton>)
    }
  />);
}
